/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-comment': {
    width: 12,
    height: 10,
    viewBox: '0 0 12 10',
    data: '<g _stroke="#c23c3c" _fill="none" fill-rule="evenodd"><path pid="0" d="M3.179 3.174h5.66M3.179 4.913h5.66"/><path pid="1" stroke-linejoin="round" d="M9.16 7.522H11V1H1v6.522h6.087v2.137z"/></g>'
  }
})
